<template>
  <div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>退票信息</span>
      </div>
      <el-form label-width="100px" style="margin-top:20px;">
        <el-form-item label="发票类型：">{{ params.invoiceType }}</el-form-item>
        <el-row>
          <el-col :span="16">
            <el-form-item label="退票原因：">
              <el-input type="textarea" :rows="3" v-model="queryParams.mark"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>申请红字发票</span>
      </div>
      <el-form label-width="100px" style="margin-top:20px;">
        <el-row>
          <el-col :span="8">
            <el-form-item label="发票类型：">{{ params.invoiceType }}</el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="关联发票编号：">{{ params.invoiceCode }}</el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!--------------------------------------- 退票信息 -------------------------------------->
    <div class="item-box-content">
      <el-form label-width="100px">
        <el-row>
          <el-col :span="20">
            <div class="title-font-style">
              <span>退票信息</span>
            </div>
          </el-col>
          <el-col :span="4" style="text-align:right">
            <el-button @click="isShow = true" v-show="!isShow">修改</el-button>
            <el-button @click="onSave" v-show="isShow">保存</el-button>
          </el-col>
        </el-row>
        <div v-show="!isShow">
          <el-row :gutter="20" style="margin-top:20px;">
            <el-col :span="8">
              <el-form-item label="收票人：">{{ queryParams.ciRecevier }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话：">{{ queryParams.ciRecevierPhone }}</el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="收票地址：">{{ queryParams.ciRecevierProvince }}</el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="详细地址：">{{ queryParams.ciRecevierAddress }}</el-form-item>
            </el-col>
          </el-row>
        </div>
        <div v-show="isShow">
          <el-row :gutter="20" style="margin-top:20px;">
            <el-col :span="8">
              <el-form-item label="收票人：">
                <el-input v-model="queryParams.ciRecevier"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="联系电话：">
                <el-input @input.native="onInput" v-model="queryParams.ciRecevierPhone"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <el-form-item label="收票地址：">
                <el-address
                  ref="addressRefs"
                  :provinceEdit="provinceEdit"
                  :city="city"
                  :district="district"
                  @changAddress="changAddress($event)"
                ></el-address>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item label="详细地址：">
                <el-input v-model="queryParams.ciRecevierAddress"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </el-form>
    </div>
    <div class="item-box-content">
      <div class="title-font-style">
        <span>退票清单</span>
      </div>
      <el-row :gutter="20">
        <!--------------------------------------- 已开票产品 -------------------------------------->
        <el-col :span="12">
          <div class="join-remove-sell">
            <div class="table-title">已开票产品</div>
            <div class="totals"></div>
            <el-table
              border
              :data="productList"
              :header-cell-style="tableHeader"
              empty-text="产品已全部移入退票区！"
              v-loading="loadingProTable"
              height="430px"
              element-loading-text="拼命加载中请稍后..."
              element-loading-spinner="el-icon-loading"
              @selection-change="handleSelectionImm"
              @row-dblclick="dblclickL"
            >
              <el-table-column fixed type="selection" width="35"></el-table-column>
              <el-table-column prop="proName" label="产品名称" width="120" show-overflow-tooltip></el-table-column>
              <el-table-column prop="proType" label="型号" show-overflow-tooltip></el-table-column>
              <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip width="120"></el-table-column>
              <el-table-column prop="contractCode" label="销售合同编号" show-overflow-tooltip width="110"></el-table-column>
              <el-table-column
                prop="outstockNumber"
                label="出库单编号"
                show-overflow-tooltip
                width="120"
              ></el-table-column>
              <el-table-column label="销售单价" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.cbPrice|priceFilterNum}}</template>
              </el-table-column>
              <el-table-column prop="count" label="数量" width="80"></el-table-column>
            </el-table>
            <el-col :span="24" class="join-remove-sell-btn">
              <el-button type="primary" @click="immigrateAll">全部移入</el-button>
              <el-button type="primary" @click="immigrate" plain>移入退票区</el-button>
            </el-col>
          </div>
        </el-col>
        <!--------------------------------------- 退票区 -------------------------------------->
        <el-col :span="12">
          <div class="join-remove-sell">
            <div class="table-title">退票区</div>
            <div class="totals">退票总额：{{ totals|priceFilterNum }}</div>
            <el-table
              border
              :data="repAvacList"
              :header-cell-style="tableHeader"
              height="430px"
              element-loading-spinner="el-icon-loading"
              @selection-change="handleSelectionRe"
              @row-dblclick="dblclickR"
              empty-text="请选择退票产品！"
            >
              <el-table-column fixed type="selection" width="35"></el-table-column>
              <el-table-column prop="proName" label="产品名称" width="120" show-overflow-tooltip></el-table-column>
              <el-table-column prop="proType" label="型号" show-overflow-tooltip width="80"></el-table-column>
              <el-table-column prop="orderNumber" label="订货号" show-overflow-tooltip width="90"></el-table-column>
              <el-table-column prop="contractCode" label="销售合同编号" show-overflow-tooltip width="110"></el-table-column>
              <el-table-column
                prop="outstockNumber"
                label="出库单编号"
                show-overflow-tooltip
                width="110"
              ></el-table-column>
              <el-table-column label="销售单价" show-overflow-tooltip>
                <template slot-scope="scope">{{scope.row.cbPrice|priceFilterNum}}</template>
              </el-table-column>
              <el-table-column label="数量" width="125" fixed="right">
                <template slot-scope="scope">
                  <el-input-number
                    style="width:100%"
                    v-model="scope.row.count"
                    @change="handleNumber(scope.row)"
                    :min="1"
                    controls-position="right"
                    :max="scope.row.max"
                  ></el-input-number>
                </template>
              </el-table-column>
            </el-table>
            <el-col :span="24" class="join-remove-sell-btn">
              <el-button type="primary" @click="onRemoveAll">全部移出</el-button>
              <el-button type="primary" @click="onRemove" plain>移出退票区</el-button>
            </el-col>
          </div>
        </el-col>
      </el-row>
    </div>
    <div>
      <el-button @click="onApplyForReturnTicket" type="primary">申请退票</el-button>
    </div>
    <div style="margin-top:16px;">申请红字发票需提供红字信息表交予财务部门，退票成功后请尽快领取</div>
    <el-dialog
      :visible.sync="disableDialog"
      title="修改开票信息"
      @close="onCancel"
      append-to-body
      width="414px"
    >
      <span style="padding-left:30px;">开票信息已修改，请问是否同步更新客户资料-开票信息？</span>
      <span slot="footer" class="dialog-center">
        <el-button type="primary" @click="onSubmit">确 定</el-button>
        <el-button @click="disableDialog=false">取 消</el-button>
      </span>
    </el-dialog>
    <!-------------- 申请退票二次确认 -------------->
    <open-or-close
      ref="OpenOrCloseRefs"
      @onUpdataState="onUpdataState"
      title="确认退票"
      content="退票申请发起后不可撤回，是否确认退票？"
    ></open-or-close>
  </div>
</template>
<script>
import address from '@/components/Address/index'
import OpenOrClose from '@/components/OpenOrClose/index'
import {
  customerInvoice,
  redSubQueryByOciId,
  orderContractInvoiceSubAdd,
  ReturnGoodsInvoice,
  ReturnGoodsInvoiceCommit
} from '@/api/sell/sellManage'
export default {
  components: {
    'el-address': address,
    'open-or-close': OpenOrClose
  },
  data() {
    return {
      params: {},
      queryParams: {}, // 收票信息
      provinceEdit: {},
      city: {},
      district: {},
      type: 0,
      customerInvoice: {}, // 原始收票信息
      loadingProTable: false, // 产品清单列表区loding
      repAvacList: [], // 退票区 列表
      tempLise: [], // 退票区  选中列表
      productList: [], // 已开票产品 列表
      tempWaitLise: [], // 已开票产品 选中列表
      totals: 0, // 退票总额
      isShow: false,
      disableDialog: false,
      returnGoods: {}
    }
  },
  watch: {
    repAvacList: {
      handler(val) {
        this.totals = 0
        val.forEach((ele) => {
          this.totals += ele.count * ele.cbPrice
        })
      },
      deep: true
    }
  },
  methods: {
    onInput(e) {
      // 过滤非数字和符号-
      const regName = /^[\d-]+$/
      if (!regName.test(e.target.value)) {
        e.target.value = ''
      } else {
        return true
      }
    },
    onSave() {
      if (
        this.queryParams.ciRecevier &&
        this.queryParams.ciRecevierPhone &&
        this.queryParams.ciRecevierProvince &&
        this.queryParams.ciRecevierProcode &&
        this.queryParams.ciRecevierAddress
      ) {
        this.disableDialog = true
      } else {
        this.$message.error('信息请填写完整')
      }
    },
    onSubmit() {
      this.queryParams.cbId = this.$route.query.cusId
      customerInvoice(this.queryParams).then((res) => {
        if (res.data.code === 200) {
          this.$message.error('修改成功')
          this.isShow = false
          this.disableDialog = false
        } else {
          this.$message.error(res.data.msg)
        }
      })
    },
    onCancel() {
      this.isShow = false
      this.disableDialog = false
    },
    // 申请退票
    onApplyForReturnTicket() {
      if (!this.queryParams.mark) {
        this.$message.error('请填写完整退票信息！')
        return
      }
      if (this.repAvacList.length < 1) {
        this.$message.error('请设置退票产品！')
        return
      }
      if (this.isShow) {
        this.$message.error('请保存收票信息！')
        return
      }
      if (
        !this.queryParams.ciRecevierPhone ||
        !this.queryParams.ciRecevier ||
        !this.queryParams.ciRecevierProvince
      ) {
        this.$message.error('请填写收票信息！')
        return
      }
      this.$refs.OpenOrCloseRefs.onInitial()
    },
    // 二次确认弹窗
    onUpdataState() {
      const obj = {
        ...this.params,
        ...this.queryParams,
        obId: this.params.ocbId,
        ociId: this.params.id,
        orderContractInvoiceSubContents: this.repAvacList,
        subType: 1
      }
      obj.amount = this.totals
      if (this.$route.query.oscId) {
        obj.orderContractSalereturnGoods = this.returnGoods
        obj.ocsgId = this.$route.query.oscId
        ReturnGoodsInvoiceCommit(obj).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('已申请退票，请等待审核！')
            this.$router.push({
              name: 'sellSalesReturnEdit',
              query: {
                id: this.$route.query.oscId,
                cusId: this.$route.query.cusId
              }
            })
          }
        })
      } else {
        orderContractInvoiceSubAdd(obj).then((res) => {
          if (res.data.code === 200) {
            this.$message.success('已申请退票，请等待审核！')
            this.$router.push({
              name: 'contractEdit',
              query: {
                id: this.$route.query.id,
                cusId: this.$route.query.cusId
              }
            })
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    getList(val) {
      this.params = val
      this.$set(this.params, 'invoiceType', '红字发票')
      if (this.$route.query.oscId) {
        ReturnGoodsInvoice(
          val.id,
          val.invoiceNumber,
          this.$route.query.oscId
        ).then((res) => {
          if (res.data.code === 200) {
            this.queryParams = JSON.parse(
              JSON.stringify(res.data.obj.customerInvoice)
            )
            const recParams = this.$analysisAddress(
              res.data.obj.customerInvoice.ciRecevierProcode,
              res.data.obj.customerInvoice.ciRecevierProvince
            )
            this.provinceEdit = recParams.province
            this.city = recParams.city
            this.district = recParams.district
            res.data.obj.orderContractInvoiceStateVoList.forEach((ele) => {
              ele.max = ele.count = ele.quantity
              ele.occId = ele.contractContentId
            })
            this.productList = res.data.obj.orderContractInvoiceStateVoList
            this.returnGoods = res.data.obj.orderContractSalereturnGoods
          }
        })
      } else {
        redSubQueryByOciId(val.id, val.invoiceNumber).then((res) => {
          if (res.data.code === 200) {
            const recParams = this.$analysisAddress(
              res.data.obj.customerInvoice.ciRecevierProcode,
              res.data.obj.customerInvoice.ciRecevierProvince
            )
            this.provinceEdit = recParams.province
            this.city = recParams.city
            this.district = recParams.district
            this.queryParams = JSON.parse(
              JSON.stringify(res.data.obj.customerInvoice)
            )
            res.data.obj.orderContractInvoiceStateVoList.forEach((ele) => {
              ele.max = ele.count = ele.quantity
              ele.occId = ele.contractContentId
            })
            this.productList = res.data.obj.orderContractInvoiceStateVoList
          } else {
            this.$message.error(res.data.msg)
          }
        })
      }
    },
    changAddress(val) {
      // 收件人地址改变
      this.queryParams.ciRecevierProvince = val.name
      this.queryParams.ciRecevierProcode = val.code
    },
    // -------------------   产品清单   ----------------
    onRemoveAll() {
      // 全部移出
      this.tempLise = JSON.parse(JSON.stringify(this.repAvacList))
      this.onRemove()
    },
    dblclickR(row) {
      this.tempLise = [row]
      this.onRemove()
    },
    onRemove() {
      if (this.tempLise.length === 0) {
        this.$message.error('请选中产品！')
      } else {
        this.tempLise.forEach(m => {
          const i = this.productList.findIndex(n => n.proId === m.proId && n.stateSort === m.stateSort)
          m.count = m.max
          if (i === -1) {
            this.productList.push(m)
          } else {
            this.productList.splice(i, 1, m)
          }
          const int = this.repAvacList.findIndex(n => n.proId === m.proId && n.stateSort === m.stateSort)
          this.repAvacList.splice(int, 1)
        })
        this.tempLise = []
      }
    },
    handleSelectionRe(val) {
      this.tempLise = val
    },
    handleNumber(row) {
      // 计数器加减
      if (!row.count) {
        this.dblclickR(row)
        return
      }
      const num = row.max - row.count
      if (num === 0) {
        this.productList.forEach((ele, index) => {
          if (ele.proId === row.proId && ele.stateSort === row.stateSort) {
            this.productList.splice(index, 1)
          }
        })
      } else {
        let isParam = false
        for (let i = 0; i < this.productList.length; i++) {
          if (
            this.productList[i].proId === row.proId &&
            this.productList[i].stateSort === row.stateSort
          ) {
            isParam = true
            this.productList[i].count = num
          }
        }
        if (!isParam) {
          const params = JSON.parse(JSON.stringify(row))
          params.count = num
          this.productList.push(params)
        }
      }
    },
    handleSelectionImm(val) {
      this.tempWaitLise = val
    },
    immigrate() {
      if (this.tempWaitLise.length === 0) {
        this.$message.error('请选中产品！')
      } else {
        this.tempWaitLise.forEach(m => {
          const i = this.repAvacList.findIndex(n => n.proId === m.proId && n.stateSort === m.stateSort)
          m.count = m.max
          if (i === -1) {
            this.repAvacList.push(m)
          } else {
            this.repAvacList.splice(i, 1, m)
          }
          const int = this.productList.findIndex(n => n.proId === m.proId && n.stateSort === m.stateSort)
          this.productList.splice(int, 1)
        })
        this.tempWaitLise = []
      }
    },
    dblclickL(row) {
      this.tempWaitLise = [row]
      this.immigrate()
    },
    immigrateAll() {
      // 全部移入
      this.tempWaitLise = JSON.parse(JSON.stringify(this.productList))
      this.immigrate()
    },
    tableHeader({ rowIndex }) {
      return this.$tableHeader(rowIndex)
    }
  }
}
</script>
<style lang="scss" scoped>
.totals {
  margin-bottom: 10px;
  padding-right: 20px;
  height: 21px;
  text-align: right;
  font-size: 12px;
  font-weight: 500;
  color: #276cff;
  line-height: 21px;
}
</style>
